import * as Yup from 'yup'

export const buildValidationSchema = () => {
  const addressRequired = (receiptDesired: boolean) => receiptDesired
  const cappedString = Yup.string().max(255, i18n.t('donate.errors.too_long'))
  const requiredCappedString = cappedString.required(i18n.t('donate.errors.blank'))
  const validateAddressPart = Yup.string().when(['receipt_desired', 'payment_method'], {
    is: addressRequired,
    then: () => requiredCappedString,
  })
  const validateCaptcha = Yup.boolean().when(['channel', '_step'], {
    is: (channel: string, step: number) => {
      return (channel !== 'iframe' || step === 1) && !document.body.classList.contains('env-test')
    },
    then: () =>
      Yup.boolean()
        .required(i18n.t('donate.errors.captcha_required'))
        .oneOf([true], i18n.t('donate.errors.captcha_required')),
  })

  return Yup.object().shape({
    amount_cents: Yup.number()
      .typeError(i18n.t('donate.errors.invalid'))
      .min(100, i18n.t('donate.errors.greater_than'))
      .max(2000000, i18n.t('donate.errors.exceeds_platform_limit')),
    display_name: cappedString,
    first_name: requiredCappedString,
    last_name: requiredCappedString,
    _company_donation: Yup.boolean(),
    receipt_desired: Yup.boolean(),
    company_name: Yup.string().when('_company_donation', {
      is: true,
      then: () => requiredCappedString,
    }),
    street: validateAddressPart,
    city: validateAddressPart,
    zip: validateAddressPart,
    email: Yup.string()
      .email(i18n.t('donate.errors.invalid'))
      .max(255, i18n.t('donate.errors.too_long'))
      .required(i18n.t('donate.errors.blank')),
    _captcha_complete: validateCaptcha,
  })
}
